import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsTool',
    props: {
        trsTool: null
    },
    emits: ["onImport"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faUpload);
        function importVersion(version) {
            const version_id = version.id.includes(`:${version.name}`) ? version.name : version.id;
            emit("onImport", version_id);
        }
        return { __sfc: true, props, emit, importVersion, faUpload, FontAwesomeIcon, BButton };
    }
});
